module.exports = __webpack_public_path__ + "img/12.09d6a5e0.jpg";